// extracted by mini-css-extract-plugin
module.exports = {"tableBox":"Table_tableBox__U1oMp","headerAll":"Table_headerAll___tL0R","sliderDiv":"Table_sliderDiv__e61nT","tableDiv":"Table_tableDiv__1BD42","tableBody":"Table_tableBody__1sqBX"};